module.exports = __webpack_public_path__ + "fonts/open-sans-v15-cyrillic-700.b543521.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/open-sans-v15-cyrillic-700.woff2
// module id = kUo7
// module chunks = 13